import { Users, Zap, CreditCard, DollarSign } from "lucide-react";
import { StatCard, BarChart } from "./AdminComponents";

const AdminDashboard = ({ dash }) => (
  <div className="space-y-6" data-testid="admin-dashboard-tab">
    {/* Top Stats */}
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <StatCard icon={Users} label="Total Users" value={dash.users?.total || 0} color="sky" />
      <StatCard icon={Zap} label="Active Users" value={dash.users?.active || 0} sub="Last 7 days" color="emerald" />
      <StatCard icon={CreditCard} label="Paid Users" value={dash.users?.paid || 0} color="amber" />
      <StatCard icon={DollarSign} label="MRR" value={`$${(dash.revenue?.mrr || 0).toFixed(0)}`} sub={`ARR: $${(dash.revenue?.arr || 0).toFixed(0)}`} color="violet" />
    </div>

    {/* Signup Trends */}
    <div className="bg-slate-900/70 rounded-xl border border-white/5 p-5">
      <h3 className="text-sm font-semibold text-white mb-4">User Signup Trends (30 days)</h3>
      <BarChart data={dash.signup_trend || []} dataKey="count" height={100} color="#8b5cf6" />
    </div>

    {/* Distribution + Content */}
    <div className="grid md:grid-cols-2 gap-4">
      {/* Pie-like distribution */}
      <div className="bg-slate-900/70 rounded-xl border border-white/5 p-5">
        <h3 className="text-sm font-semibold text-white mb-4">User Distribution</h3>
        <div className="flex items-center gap-6">
          <div className="relative w-28 h-28">
            <svg viewBox="0 0 36 36" className="w-full h-full">
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#1e293b" strokeWidth="3" />
              <circle
                cx="18" cy="18" r="15.9" fill="none" stroke="#8b5cf6" strokeWidth="3"
                strokeDasharray={`${((dash.user_distribution?.paid || 0) / Math.max((dash.users?.total || 1), 1)) * 100} 100`}
                strokeLinecap="round" transform="rotate(-90 18 18)"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-lg font-bold text-white">{dash.users?.total || 0}</span>
              <span className="text-[10px] text-slate-400">total</span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-violet-500" />
              <span className="text-sm text-slate-300">Paid: {dash.user_distribution?.paid || 0}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-slate-700" />
              <span className="text-sm text-slate-300">Free: {dash.user_distribution?.free || 0}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content Stats */}
      <div className="bg-slate-900/70 rounded-xl border border-white/5 p-5">
        <h3 className="text-sm font-semibold text-white mb-4">Content</h3>
        <div className="grid grid-cols-2 gap-3">
          {Object.entries(dash.content || {}).map(([k, v]) => (
            <div key={k} className="flex items-center gap-2">
              <span className="text-lg font-bold text-white">{v}</span>
              <span className="text-xs text-slate-400 capitalize">{k.replace("_", " ")}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default AdminDashboard;
